export const customerDetailsHeaderPopUpDetails = [
  { key: "fileaClaim", value: "File a Claim" },
  { key: "edit", value: "Edit" },
  { key: "email", value: "Email" },
  { key: "call", value: "Call" },
  { key: "market", value: "Marketing" },
  { key: "addNotes", value: "Add Notes" },
];
